"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceUrlParamVal = exports.genUrlWithSearch = exports.convertParams = exports.getSearchParamValue = exports.getPathSearchParams = exports.compatibleProtocolLessUrl = exports.compatibleWebpImage = exports.transferAlisize = exports.compatibleQiniuAndGeneralImage = void 0;
var debug_1 = require("./debug");
var isSupportWebP_1 = require("./browser/isSupportWebP");
var uri_1 = require("./browser/uri");
var qiniuProURL1 = "//i.ezbuy.sg/";
var qiniuUATURL = "http://7xiata.com1.z0.glb.clouddn.com/";
var qiniuImageOrigin = [
    qiniuProURL1,
    "http://7xiuv9.com5.z0.glb.clouddn.com/",
    qiniuUATURL,
    "//i2.ezbuy.sg/"
];
var hashReg = /#[^?]*/;
function isQiniuImage(imageUrl) {
    return qiniuImageOrigin.some(function (url) { return imageUrl.indexOf(url) !== -1; });
}
function isI2Origin(imageUrl) {
    return /^(?:https?\:)?\/\/i2\.ezbuy\.sg\//.test(imageUrl);
}
exports.compatibleQiniuAndGeneralImage = function (imageUrl, params) {
    if (params === void 0) { params = ""; }
    var search = "";
    if (params) {
        search = "" + (isI2Origin(imageUrl) ? "%3F" : "?") + params;
        if (!params.includes("/q/")) {
            search = search + "/q/90";
        }
        if (isSupportWebP_1.default() && !params.includes("/format/")) {
            search = search + "/format/webp";
        }
    }
    if (/^(?:https?\:)?\/\//.test(imageUrl)) {
        if (isQiniuImage(imageUrl) && imageUrl.indexOf("?") === -1) {
            return "" + imageUrl + search;
        }
        return imageUrl;
    }
    var qiniuDomain = qiniuProURL1;
    if (debug_1.isUAT()) {
        qiniuDomain = qiniuUATURL;
    }
    return "" + qiniuDomain + imageUrl + search;
};
var aliImageUrlRegex = /(?:(?:taobaocdn)|(?:alicdn))\.com(?:(?:[\w\W]+item_pic)|(?:\/bao\/uploaded[\w\W]+)|(?:\/imgextra[\w\W]+))\.(?:(?:jpg)|(?:png))$/;
var aliImageUrlWithQueryRegex = /\.((?:jpg)|(?:png)|(?:gif))_(\d+)x\2([\w\d]+)\.\1$/;
exports.transferAlisize = function (imageUrl, alisize) {
    var suffix = isSupportWebP_1.default() ? "_.webp" : ".jpg";
    if (alisize > 0) {
        if (aliImageUrlRegex.test(imageUrl)) {
            if (aliImageUrlWithQueryRegex.test(imageUrl)) {
                var result = aliImageUrlWithQueryRegex.exec(imageUrl);
                return "" + imageUrl.replace("_" + result[2] + "x" + result[2] + result[3] + "." + result[1], "" + ("_" + alisize * 100 + "x" + alisize * 100 + suffix));
            }
            return imageUrl + "_" + alisize * 100 + "x" + alisize * 100 + suffix;
        }
    }
    return imageUrl;
};
exports.compatibleWebpImage = function (imageUrl) {
    if (!isSupportWebP_1.default()) {
        return imageUrl.replace(/_\.webp$/i, "");
    }
    return imageUrl;
};
var protocolLessDomains = [
    "65daigou.com",
    "ezbuy.sg",
    "ezbuy.co.id",
    "ezbuy.co.th",
    "ezbuy.my",
    "img.alicdn.com",
    "i.ezbuy.sg"
];
var protocolLessDomainMathRegex = protocolLessDomains.map(function (domain) { return new RegExp("//" + domain.replace(/\./g, ".")); });
var httpProtocolRegexp = /^(?:https?:)\/\//i;
exports.compatibleProtocolLessUrl = function (imageUrl) {
    var isUrlSupportProtocolLess = protocolLessDomainMathRegex.findIndex(function (regexp) { return regexp.test(imageUrl); }) !== -1;
    if (isUrlSupportProtocolLess) {
        return imageUrl.replace(httpProtocolRegexp, "//");
    }
    return imageUrl;
};
exports.getPathSearchParams = function (url) {
    if (url === void 0) { url = ""; }
    var obj = {};
    var str = "";
    var strArr = [];
    var splitSearchParamReg = /([^=]+)=(.+)/;
    if (url.trim() === "" || url[0] !== "?") {
        return obj;
    }
    url = url.replace(/^\?+/gi, "?");
    if (url.length < 2) {
        return obj;
    }
    str = url.substring(1);
    strArr = str.split("&");
    for (var i = 0; i < strArr.length; i++) {
        var s = strArr[i];
        if (s.indexOf("=") === -1) {
            continue;
        }
        var result = s.match(splitSearchParamReg);
        if (result === null) {
            continue;
        }
        var prp = result[1];
        var val = result[2];
        obj[prp] = uri_1.tryDecodeURIComponent(val);
    }
    return obj;
};
function getSearchParamValue(searchKey, url) {
    if (url === void 0) { url = ""; }
    url = url || location.search;
    var searchParams = exports.getPathSearchParams(url);
    var keyReg = new RegExp("^" + searchKey + "$", "i");
    var value = "";
    for (var prp in searchParams) {
        if (keyReg.test(prp)) {
            value = searchParams[prp];
        }
    }
    return value;
}
exports.getSearchParamValue = getSearchParamValue;
function convertParams(params) {
    var paramsList = [];
    if (params && Object.keys(params).length) {
        for (var p in params) {
            if (params[p] !== "" && params[p] !== undefined) {
                paramsList.push(p + "=" + encodeURIComponent(params[p]));
            }
        }
    }
    return paramsList.join("&");
}
exports.convertParams = convertParams;
function genUrlWithSearch(url, params) {
    if (url === void 0) { url = ""; }
    if (url === undefined || url === "") {
        return "";
    }
    var postUrl = url;
    var hash = "";
    var hashResult = url.match(hashReg);
    if (hashResult !== null) {
        postUrl = url.replace(hashReg, "");
        hash = hashResult[0];
    }
    var searchString = convertParams(params);
    var startChat = "?";
    if (postUrl.includes("?")) {
        startChat = postUrl.endsWith("&") ? "" : "&";
    }
    return !!searchString ? "" + postUrl + startChat + searchString + hash : "" + url + hash;
}
exports.genUrlWithSearch = genUrlWithSearch;
exports.replaceUrlParamVal = function (paramName, replaceWith, url) {
    if (url === void 0) { url = window.location.href; }
    var re = Function("'use strict';return (" + ("/(" + paramName + "=)([^&]*)/gi") + ")")();
    var nUrl = url.replace(re, paramName + "=" + replaceWith);
    return nUrl;
};
